import { FILLED_OPTION_SHADOW_ID } from './constants';
import filterOptions from './filterOptions';
import isEqual from './isEqual';
var MINIMUM_ACCEPTED_SCORE = 0.2;

var freeSoloFilterOptions = function freeSoloFilterOptions(options, state, intl, selectedTagOptions) {
  if (selectedTagOptions.some(function (_ref) {
    var title = _ref.title;
    return isEqual(title, state.inputValue);
  })) {
    return [{
      inputValue: '',
      id: FILLED_OPTION_SHADOW_ID,
      title: intl.formatMessage({
        id: 'tagAutocomplete.noOptionsText.filled'
      }, {})
    }];
  }

  var filteredOptionsOrdered = filterOptions(options, state, MINIMUM_ACCEPTED_SCORE);

  if (state.inputValue === '' || filteredOptionsOrdered.length > 0 && filteredOptionsOrdered.some(function (_ref2) {
    var title = _ref2.title;
    return isEqual(title, state.inputValue);
  })) {
    return filteredOptionsOrdered;
  }

  filteredOptionsOrdered.push({
    inputValue: state.inputValue,
    id: state.inputValue,
    title: intl.formatMessage({
      id: 'tagAutocomplete.createOption'
    }, {
      newOption: state.inputValue
    })
  });
  return filteredOptionsOrdered;
};

export default freeSoloFilterOptions;